import axios from 'axios';

export const createBusinessSettings = async (formData) => {
  try {
    const response = await axios.post('/business', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllBusinessSettings = async () => {
  try {
    const response = await axios.get('/business');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getBusinessSettingsById = async (id) => {
  try {
    const response = await axios.get(`/business/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateBusinessSettings = async (id, formData) => {
  try {
    const response = await axios.put(`/business/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteBusinessSettings = async (id) => {
  try {
    const response = await axios.delete(`/business/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};